module.exports = __webpack_public_path__ + "img/page_in_development.23a38f5a.svg";